export default __webpack_public_path__ + "static/media/active.847154fa.png";